export default class Footer {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.footer'), el => {
            new Footer(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.accordions = element.querySelectorAll('.footer__accordion');
        this.menuTitles = element.querySelectorAll('.footer__menu-title');

        // Add click event listeners to menu titles
        Array.prototype.forEach.call(this.menuTitles, menuTitle => {
            menuTitle.addEventListener('click', (e) => {
                // Only apply the functionality on screens smaller than 992px (lg breakpoint)
                if (window.innerWidth < 992) {
                    const accordion = menuTitle.closest('.footer__accordion');
                    if (accordion) {
                        this.toggleAccordion(accordion);
                    }
                }
            });
        });
    }

    toggleAccordion(accordion) {
        // If the clicked accordion is already open, close it
        if (accordion.classList.contains('footer__accordion--open')) {
            accordion.classList.remove('footer__accordion--open');
        } else {
            // Close all accordions
            Array.prototype.forEach.call(this.accordions, acc => {
                acc.classList.remove('footer__accordion--open');
            });

            // Open the clicked accordion
            accordion.classList.add('footer__accordion--open');
        }
    }
}
